<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">上传模板</h1>
            <el-form class="form-container" :model="info" :rules="modelRules" ref="addModelForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">模板名称：</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="name">
                        <el-input
                            placeholder="请输入模板名称"
                            class="input-control"
                            v-model="info.name"
                        ></el-input>
                        </el-form-item>
                    </div>
                </div>
              
                <div class="form-item" style="height: 152px">
                    <div class="form-label">
                        <span class="label">封面图：</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="cover_img"> 
                        <div class="huxing-input">
                            <div
                            class="upload-group clearfix"
                            v-if="info.full_img && info.full_img !== ''"
                            >
                            <div class="upload-item">
                                <img :src="info.full_img" alt />
                                <div class="shadow">
                                <i class="el-icon-delete" @click="clearUpload"></i>
                                </div>
                            </div>
                            </div>
                            <div class="upload-group-2" v-else>
                            <i class="el-icon-plus"></i>
                            <input
                                type="file"
                                class="type-file"
                                accept="*"
                                @change="checkFile($event)"
                                id="pictureUploadFile"
                            />
                            </div>
                            <p class="tip">用于后台展示（1M以内）</p>
                        </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item" style="height: 152px">
                    <div class="form-label">
                        <span class="label">选择文件</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="path">
                        <div class="huxing-input">
                            <div
                            class="upload-group clearfix"
                            v-if="info.path && info.path !== ''"
                            >
                            <div class="upload-item">
                                <img :src="zipUrl" alt />
                                <div class="shadow">
                                <i class="el-icon-delete" @click="clearUploadZt"></i>
                                </div>
                            </div>
                            </div>
                            <div class="upload-group-2" v-else>
                            <i class="el-icon-plus"></i>
                            <input
                                type="file"
                                class="type-file"
                                accept="zip"
                                @change="checkZtFile($event)"
                                id="pictureUploadZt"
                            />
                            </div>
                            <p class="tip">
                                请上传.zip格式的压缩包（10M以内）
                            </p>
                        </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('addModelForm')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import { uploadModelFile , addTopicModel } from '@/service/zhuanti'
    import { uploadFile } from "@/service/wikipedia";
    import { UPLOAD_CODE } from "@/config/index";
    export default {
        name: "add",
        components: {
            PopoverRight,
        },
        props: {
            callback: Function
        },
        data () {

            return {
              
                info: {
                   name:'',
                   path:'',
                   cover_img:'',
                   full_img:'',
                },
                zipUrl:'',
                modelRules: {
                    name: [
                            { required: true, message: '请填写模板名称', trigger: 'blur' },
                            { min: 1, max: 50, message: "长度在 2 到 64 个字符", trigger: "blur" },
                        ],
                    cover_img:[{ required: true, message: "请上传封面图" }],
                    path: [{ required: true, message: "请上传模板文件" }],

                },
            }
        },
        mounted () {

        },
        methods : {
            async open () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.resetForm();
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                this.$refs.addModelForm && this.$refs.addModelForm.clearValidate()
            },
            resetForm () {
                this.info = {
                    name:'',
                    path:'',
                    cover_img:'',
                    full_img:'',
                }
            },
            zipImg() {
                if (process.env.NODE_ENV === "development") {
                    this.zipUrl = process.env.VUE_APP_RESOURCE_URL + "/image/zip_icon.jpg";
                } else {
                    this.zipUrl =
                    window.serverConfig[window.siteMap[domain]].VUE_APP_RESOURCE_URL +
                    "/image/zip_icon.jpg";
                }
            },
            checkFile(e) {
                const file = e.target;
                const filePath = file.value;
                if (!filePath) return false;
                if (!/.(jpg|jpeg|png|webp)$/.test(filePath)) {
                    this.$message({
                    type: "error",
                    message: "请选择JPG/PNG/JPEG/WEBP格式的图片",
                    });
                    return false;
                }
                const fileSize = file.files[0].size;
                if (fileSize / 1024 / 1024 > 1) {
                    this.$message({
                    type: "error",
                    message: "上传的图片不能大于1M",
                    });
                    return false;
                }
                this.upload(file.files[0]);
            },
            async upload(file) {
                try {
                    const formData = new FormData();
                    formData.append("file", file);
                    formData.append("code", UPLOAD_CODE.topic);
                    const res = await uploadFile(UPLOAD_CODE.topic, formData);
                    this.$set(this.info, "cover_img", res.path);
                    this.$set( this.info, "full_img","https://" + res.full_url + "!watermark"
                    );
                } catch (error) {
                    this.$message({
                    type: "error",
                    message: error.message || "上传图片错误",
                    });
                }
            },
            clearUpload() {
                this.$set(this.info, "cover_img", "");
                this.$set(this.info, "full_img", null);
                document.querySelector("#pictureUploadFile").value = "";
            },
            checkZtFile(e) {
                const file = e.target;
                const filePath = file.value;
                if (!filePath) return false;
                if (!/.(zip)$/.test(filePath)) {
                    this.$message({
                    type: "error",
                    message: "请选择zip格式",
                    });
                    return false;
                }
                const fileSize = file.files[0].size;
                if (fileSize / 1024 / 1024 > 10) {
                    this.$message({
                    type: "error",
                    message: "上传的压缩包不能大于10M",
                    });
                    return false;
                }
                this.uploadZhuanti(file.files[0]);
            },
            uploadZhuanti(file) {
                this.loading = true;
                const formData = new FormData();
                formData.append("file", file);
                uploadModelFile(UPLOAD_CODE.topicTemplate, formData)
                    .then((res) => {
                    this.loading = false;
                    this.$set(this.info, "path", res.path);
                    this.zipImg();
                    })
                    .catch((err) => {
                    this.loading = false;
                    this.zipUrl = "";
                    const message = err.message;
                    this.$message({
                        message: message || "上传模板文件接失败",
                        type: "error",
                        duration: 3 * 1000,
                    });
                });
            },
            clearUploadZt() {
                this.$set(this.info, "path", "");
            },
            submitForm(formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                    let query = this.info;
                    addTopicModel(query)
                        .then((data) => {
                        this.$message({
                            message: "添加成功",
                            type: "success",
                            duration: 3 * 1000,
                        });
                        this.hide();
                        this.callback && this.callback();

                        })
                        .catch((err) => {
                        this.$message({
                            message: err.message || "添加失败",
                            type: "error",
                            duration: 3 * 1000,
                        });
                        });
                    } else {
                    return false;
                    }
                });
            },
        },
    }
</script>

<style scoped lang="less">
.upload-group-2 {
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .el-icon-plus {
    font-size: 30px;
    color: #999;
  }
  .type-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  input{
      height: 152px !important;;
  }
}
.upload-group {
  .upload-item {
    width: 150px;
    height: 150px;
    position: relative;
    float: left;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
    .shadow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: -webkit-box;
      -webkit-box-align: center;
      -webkit-box-pack: center;
      cursor: pointer;
      transition: all 0.1s linear;
      opacity: 0;
      .el-icon-delete {
        font-size: 21px;
        color: #fff;
        display: block;
      }
    }
    &:hover {
      .shadow {
        opacity: 1;
      }
    }
    .el-icon-close {
      position: absolute;
    }
  }
}
p.tip{
    color: #666;
    margin-left: 20px;
    line-height: 152px;
}
.huxing-input{
    display: -webkit-box;
    height: 152px;
}
.huxing-input {
  display: -webkit-box;
  height: 152px;
  .el-form-item {
    -webkit-box-flex: 1;
  }
  .labels {
    font-size: 13px;
    color: #666;
    padding: 0 8px;
    display: block;
  }
  .flex-all {
    -webkit-box-flex: 1;
  }
}
</style>
